import {guardedFetcher} from 'src/utils/guardedFetcher';

export const GrantsService = {
  get: () => guardedFetcher.get('auth/grantsets'),
};
